import type { FormEvent } from "react";
import type { ProviderDefinition } from "./workflowToolsProviders";
import styles from "./workflow.module.scss";

interface WorkflowProviderConnectFormProps {
  provider: ProviderDefinition;
  values: Record<string, string>;
  saving: boolean;
  onClose: () => void;
  onSubmit: (e: FormEvent) => void;
  onChange: (key: string, value: string) => void;
}

export const WorkflowProviderConnectForm = ({
  provider, values, saving, onClose, onSubmit, onChange,
}: WorkflowProviderConnectFormProps) => (
  <form className={styles.providerForm} onSubmit={onSubmit}>
    <div className={styles.providerFormHeader}>
      <div className={styles.providerFormTitle}>
        <span className={styles.providerFormIcon} style={{ background: provider.bgColor }}>
          {provider.icon}
        </span>
        <div>
          <h3>Connect to {provider.name}</h3>
          <p>Fill in your connection details. Sensitive fields will be encrypted automatically.</p>
        </div>
      </div>
      <button type="button" className={styles.providerFormClose} onClick={onClose} aria-label="Close">
        &times;
      </button>
    </div>
    <div className={styles.providerFormFields}>
      {provider.fields.map(field => (
        <label key={field.key} htmlFor={`provider-field-${field.key}`} className={styles.providerField}>
          <span className={styles.providerFieldLabel}>
            {field.label}
            {field.type === "password" && (
              <span className={styles.providerFieldEncrypted}>encrypted</span>
            )}
          </span>
          <input
            id={`provider-field-${field.key}`}
            type={field.type ?? "text"}
            value={values[field.key] ?? ""}
            onChange={e => onChange(field.key, e.target.value)}
            placeholder={field.placeholder}
          />
        </label>
      ))}
    </div>
    <div className={styles.providerFormActions}>
      <button type="button" className={styles.cancelBtn} onClick={onClose}>Cancel</button>
      <button type="submit" className={styles.saveBtn} disabled={saving} style={{ background: provider.color }}>
        {saving ? "Saving..." : `Save ${provider.name} Connection`}
      </button>
    </div>
  </form>
);
